import React from 'react';
import styled from 'styled-components/macro';
import { Tables } from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import IndividualResponse from './IndividualResponse';

const { Table, TableBody, TableHeader } = Tables;

const TabelStyled = styled(Table)``;

const TableHeaderStyled = styled(TableHeader)`
  th {
  }
`;

const TableWrapper = styled.div`
  padding: 1.5rem 2.5rem;
`;

export interface RowData {
  date: string;
  email: string | null;
  overall_satisfaction: string;
  result_id: number;
}

interface Props {
  rows: RowData[];
  surveyUuid: string;
  organization: string;
}

const IndivudialReportsTable = ({ rows, surveyUuid, organization }: Props) => {
  const t = useFormatMessage();
  return (
    <TableWrapper>
      <TabelStyled>
        <TableHeaderStyled
          cells={[
            'ID',
            t('customerSatisfaction.individualTable.cell.date', 'Date'),
            t(
              'customerSatisfaction.individualTable.cell.email',
              'Email Address'
            ),
            t(
              'customerSatisfaction.individualTable.cell.satisfactionLvl',
              'Satisfaction Level'
            ),
            '',
          ]}
        />
        <TableBody>
          {rows.map((row: RowData, index: number) => (
            <IndividualResponse
              index={index}
              row={row}
              key={row.result_id}
              surveyUuid={surveyUuid}
              organization={organization}
            />
          ))}
        </TableBody>
      </TabelStyled>
    </TableWrapper>
  );
};

export default IndivudialReportsTable;
